module.exports = __webpack_public_path__ + "img/icon_map_wxz_c.1df1f336.png";